<template>
  <Swiper
    :modules="[SwiperPagination]"
    :slides-per-view="1"
    :space-between="16"
    :pagination="{
      clickable: true,
    }"
  >
    <SwiperSlide
      :key="1"
      class="px-4 sm:px-20"
    >
      <img
        class="mx-auto w-full"
        src="~/assets/images/Te/TeLp/Sidejob/Aff1/example-slide-1.webp"
        alt="教員時代にはできなかった柔軟な働き方を実現！"
        width="343"
        height="521"
        loading="lazy"
      >
    </SwiperSlide>
    <SwiperSlide
      :key="2"
      class="px-4 sm:px-20"
    >
      <img
        class="mx-auto w-full"
        src="~/assets/images/Te/TeLp/Sidejob/Aff1/example-slide-2.webp"
        alt="将来役に立つWeb制作スキルを身につけ副業の目標を達成！"
        width="343"
        height="521"
        loading="lazy"
      >
    </SwiperSlide>
    <SwiperSlide
      :key="3"
      class="px-4 sm:px-20"
    >
      <img
        class="mx-auto w-full"
        src="~/assets/images/Te/TeLp/Sidejob/Aff1/example-slide-3.webp"
        alt="30代事務職からフリーランスのWebデザイナーに転身！"
        width="343"
        height="521"
        loading="lazy"
      >
    </SwiperSlide>
  </Swiper>
</template>

<script setup lang="ts">
</script>

<style scoped>
@import url('~/assets/css/Te/TeCommon/TeCommonSwiper.css');
</style>
